import { render, staticRenderFns } from "./FileDownloadGlimsList.vue?vue&type=template&id=aa4b390e&"
import script from "./FileDownloadGlimsList.vue?vue&type=script&lang=js&"
export * from "./FileDownloadGlimsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports